import React from 'react';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import {useDispatch} from 'react-redux';
import Empty from '../../../_common/components/Empty';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {removeCustomerFromProject} from '../../_redux/projectsActions';
import styles from './styles.module.scss';

export const CustomersList = ({list = [], projectId}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const header = intl.formatMessage({
    id: 'projects-popup-customer-list-header', defaultMessage: 'Customers for project'
  });

  const handleRemoveCustomerToProject = (projectId, customerId) => {
    dispatch(removeCustomerFromProject(projectId, customerId.toString()));
  };

  const getList = (array) => array.map((item, index) => {
    const className = classnames('list-group-item d-flex justify-content-between align-items-center', {
      'list-group-item-secondary': index % 2 !== 0
    });

    return (
      <li className={className} key={index}>
        <div className={'d-flex align-items-center text-dark-75 font-size-base overflow-hidden text-nowrap'}>
          <div
            className={classnames('d-inline-block font-weight-bolder text-truncate', styles.customerName)}
          >
            {item.name}
          </div>
          <div className={'d-inline-block font-size-xs ml-2 mr-2'}>{item.email}</div>
        </div>
        <img
          src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
          alt="icon"
          onClick={() => handleRemoveCustomerToProject(projectId, item._id)}
          className={'cursor-pointer'}
        />
      </li>
    );
  });

  return (
    <div className={styles.customersListContainer}>
      <h3 className={'font-size-h3 text-center mb-4'}>
        {header}
      </h3>
      {
        list.length > 0
          ? (
            <ul className={classnames('list-group', styles.customersList)}>
              {getList(list)}
            </ul>
          )
          : (
            <div className={classnames('p-12 d-flex justify-content-center align-items-center', styles.customersList)}>
              <Empty/>
            </div>
          )
      }
    </div>
  );
};
